import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from 'components/Input';

import {
  isRequiredNumber,
  isRequiredNumberGreaterThan
} from 'utilities/validators';

const stdevValidateFn = isRequiredNumberGreaterThan(0);

const NormalDistributionFieldsComponent = props => (
  <div className="flex space-between baseline">
    <Field
      name="mean"
      label="Mean"
      type="number"
      component={Input}
      validate={isRequiredNumber}
      onChange={props.onMeanChange}
      wrapperClassName="mb-15 relative width-48"
      inputClassName="main-input__input"
    />

    <Field
      min={0}
      name="stdev"
      type="number"
      component={Input}
      label="St. Dev."
      validate={stdevValidateFn}
      onChange={props.onStdevChange}
      wrapperClassName="mb-15 relative width-48"
      inputClassName="main-input__input"
    />
  </div>
);

NormalDistributionFieldsComponent.propTypes = {
  onMeanChange: PropTypes.func.isRequired,
  onStdevChange: PropTypes.func.isRequired
};

export default NormalDistributionFieldsComponent;
